import { useStore } from '../store'

const useIsAdmin = () => {
  const { state } = useStore()

  const isAdmin = state?.identity?.roleTypeId === 1
  const isManager = state?.identity?.roleTypeId === 2
  const isSuperAdmin = state?.identity?.roleTypeId === 4
  const isPriveledged = isAdmin || isManager

  return { isAdmin, isManager, isPriveledged, isSuperAdmin }
}

export default useIsAdmin
